export { default } from './seoBox';
